import { useListAllRecordsQuery } from '@platform/state/api';
import type { IApiErrorPlain, IRecord, IRecordListParams } from '@platform/core/types';
import type { IAllRecords } from './IAllRecords';

const EMPTY: IRecord[] = [];

/**
 * Усі записи типу у воркспейсі — або лише відібрані `params` (фільтр, пресет; напр. scopeParams подання) — посторінково до стелі `cap`,
 * типово 1000; `total` — кількість за тим самим запитом, `capped` — записів більше, ніж завантажено. Для аналітичних подань, яким потрібен
 * повний набір, а не сторінка. Ключ кешу RTK — значення аргументів, а не посилання (параметри подання ще й тримає стабільними useScopeParams).
 * Кеш має тег списку типу: мутації записів цього типу (recordsApi) оновлюють і ці дані.
 */
export function useAllRecords(ws: string, rt: string, params?: IRecordListParams, cap?: number, skip = false): IAllRecords {
  const { data, isFetching, error, refetch } = useListAllRecordsQuery({ ws, rt, params, cap }, { skip });
  return {
    records: data?.items ?? EMPTY,
    total: data?.total ?? 0,
    capped: !!data && data.items.length < data.total,
    isLoading: isFetching,
    error: error as IApiErrorPlain | undefined,
    refetch,
  };
}
